import { RemoveMessage } from '@/core/helper/validation-rule-helper';
import { t } from 'i18next';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react'
// import DataGridWrapper from '@/core/wrappers/data-grid-wrapper';
import DataGridWrapper from '../../syncflow/components/data-grid-wrapper';
import CustomStore from 'devextreme/data/custom_store';
import React from 'react';
import { Button } from 'devextreme-react/button';
import { DataGrid, FileUploader, NumberBox, Popup, SelectBox, TextBox, Validator } from 'devextreme-react';
import { orderService } from '../../platform/services/order-service';
import DateBox, { DateBoxTypes, DisplayFormat } from 'devextreme-react/cjs/date-box';
import { useNavigate, useParams } from 'react-router-dom';
import { invoiceService } from '../services/invoice-service';
import { SelectBoxTypes } from 'devextreme-react/cjs/select-box';
import { boolean, number, string } from 'yup';
import { DataGridTypes } from 'devextreme-react/cjs/data-grid';
import DataSource from 'devextreme/data/data_source';
import ArrayStore from 'devextreme/data/array_store';
import { Config } from '@/core/config/config';
import { InvoiceRecordingVM, IOrderItemDefinition } from '@/core/interfaces/usestate-interfaces';
import { alert, confirm } from 'devextreme/ui/dialog';
import { toast } from 'react-toastify';
import { TextBoxTypes } from 'devextreme-react/cjs/text-box';
import { RequiredRule } from 'devextreme-react/cjs/validator';
import moment from 'moment';
import OrderStatusCell from '@/projects/syncflow/order/components/order-status-celll';
import { NumberBoxTypes } from 'devextreme-react/cjs/number-box';

const InvoiceRecording = () => {

    let orderId: string = "";
    let customerParams: string = "";
    let locationParams: string = "";

    const dateLabel = { 'aria-label': 'Date' };

    let dueCalDate = new Date();
    dueCalDate.setDate(dueCalDate.getDate() + 7);

    const dataGridRef = useRef<DataGrid>(null);
    const dgVendorSummaryRef = useRef<DataGrid>(null);
    const [store, setStore] = useState<CustomStore>();
    const [storeVendorSummaries, setStoreVendorSummaries] = useState<CustomStore>();

    // const validatorRefInvoice = useRef<Validator>(null);
    const validatorRefCustomer = useRef<Validator>(null);
    const validatorRefShipTo = useRef<Validator>(null);
    const validatorRefOrders = useRef<Validator>(null);
    const validatorRefTerms = useRef<Validator>(null);

    const [invoiceRecordingData, setinvoiceRecordingData] = useState<InvoiceRecordingVM>(
        {
            id: null, customer: null, comments: null, invoiceNo: null, terms: null, orders: null, billTo: null, locationCode: null,
            shipTo: null, dueDate: null, invoiceDate: null, attachments: null, invoiceDetails: null
        }
    );

    useEffect(() => {
        setStore(new CustomStore({
            key: ["id"],
            load: onGetOrderData,
            useDefaultSearch: true
        }));
    }, [])

    useEffect(() => {
        setStoreVendorSummaries(new CustomStore({
            key: ["orderLineId"],
            load: onGetVendorSummaries,
            useDefaultSearch: true
        }));
    }, [])



    const params = useParams();
    const getInvoice = async () => {
        const data = await invoiceService.getInvoice(params ? params.id : -1);
        setCommentsValue(data.comments)
        setBillToValue(data.billTo)
        setShipToValue(data.locationName)
        setInvoiceValue(data.invoiceNo)
        setCustomerValue(data.customerName)
        setinvoiceStatus(data.invoiceStatus == null ? "N" : data.invoiceStatus)
        setorderQty(data.invoiceQty)
        setvendorApprovedQty(data.receivedQty)
        setInvoiceProductCount(data.invoiceProductCount)
        setReceivedProductCount(data.receivedProductCount)
        setInvoiceAmount(data.invoiceAmount)
        setReceivedAmount(data.receivedAmount)


    };

    const onGetOrderData = useCallback(async () => {
        getInvoice();
        const x = await invoiceService.getInvoiceDetailList(params.id);
        return x;
    }, []);

    const onGetVendorSummaries = useCallback(async () => {
        if (orderId) {
            const orders = [];
            orders.push(orderId)
            const x = invoiceService.orderLinesList(orders);
            return x;
        }
    }, []);



    const onFocusedCellChanging = (e: { isHighlighted: boolean; }) => {
        e.isHighlighted = true;
    };

    const onValueChangedOrderNo = useCallback((e: SelectBoxTypes.ValueChangedEvent) => {
        if (e.value) {
            orderId = e.value;
            setOrderValue(e.value);
            dgVendorSummaryRef.current?.instance.refresh().then(x => showInfo(0));
        }
    }, []);

    // const [orderNoLookups] = useState(new CustomStore({
    //     load: invoiceService.getOrderNoLookups
    // }));

    const [customerLookups] = useState(new CustomStore({
        load: invoiceService.getVendorLookups,
    }));

    const [popupVisible, setPopupVisible] = useState(false);
    const showInfo = useCallback((e: any) => {
        setPopupVisible(true);
    }, [setPopupVisible]);

    const hideInfo = useCallback(() => {
        setPopupVisible(false);
    }, [setPopupVisible]);


    const newProductRow: any = {};
    const approveFunc = () => {
        selectedRowKeys.forEach((result: any) => {
            newProductRow.orderCode = result.orderCode;
            newProductRow.productCode = result.retailerProductCode;
            newProductRow.productName = result.retailerProductName;
            newProductRow.unit = result.unit;
            newProductRow.unitPrice = result.price;
            newProductRow.approvedQty = result.orderLinesApprovedQty;
            newProductRow.totalAmount = result.amount;

            dataGridRef.current?.instance.addRow();
        });
        hideInfo();
    }


    const handleInitNewRow = async (e: any) => {
        e.data = newProductRow;
    };

    const [selectedRowKeys, setSelectedRowKeys] = useState<any | null>(null);
    const onSelectionChanged = (args: DataGridTypes.SelectionChangedEvent) => {
        setSelectedRowKeys(args.selectedRowsData);
    };

    const uploadUrl = `${Config.VITE_APP_GATEWAY_URL}/api/replenishment-b2b/invoice/upload_invoice_attachments?InvoiceId=` + params.id

    const onSave = async () => {

        // const validationInvoiceResult = validatorRefInvoice.current?.instance.validate();
        const validationCustomerResult = validatorRefCustomer.current?.instance.validate();
        const validationShipToResult = validatorRefShipTo.current?.instance.validate();
        const validationOrdersResult = validatorRefOrders.current?.instance.validate();

        if (validationCustomerResult?.isValid && validationShipToResult?.isValid && validationOrdersResult?.isValid) {
            let result = confirm(t("syncflow:msg_save_confirm"), t("syncflow:ti_confirm"));
            result.then((dialogResult) => {
                if (dialogResult) {
                    dataGridRef.current?.instance.saveEditData().then(x => {
                    });
                }
            });
        }
    }


    const navigate = useNavigate();
    const onSaving = (e: DataGridTypes.SavingEvent) => {
        e.cancel = true;

        invoiceRecordingData.id = params ? params.id : null;
        invoiceRecordingData.attachments = "";
        invoiceRecordingData.billTo = billToValue;
        invoiceRecordingData.comments = commentsValue;
        invoiceRecordingData.customer = customerValue;
        invoiceRecordingData.dueDate = dueDate;
        invoiceRecordingData.invoiceDate = invoiceDate;
        invoiceRecordingData.invoiceNo = invoiceValue;
        invoiceRecordingData.orders = orderValue;
        invoiceRecordingData.shipTo = shipToValue;
        invoiceRecordingData.terms = termsValue;
        invoiceRecordingData.locationCode = shipToValue;
        invoiceRecordingData.invoiceDetails = e.changes;

        invoiceService.saveInvoice(invoiceRecordingData).then((response) => {
            dataGridRef.current?.instance.refresh().then(x => dataGridRef.current?.instance.cancelEditData());
            toast.success(t("syncflow:msg_saved"));
            navigate(`/b2b/invoice-list/`);
        });
    }

    const [orderValue, setOrderValue] = useState("");


    const [customerValue, setCustomerValue] = useState("");
    const onValueChangedCustomer = useCallback((e: SelectBoxTypes.ValueChangedEvent) => {
        setCustomerValue(e.value);
        getshipToLookups(e.value);
        customerParams = e.value;
    }, []);



    const [invoiceDate, setInvoiceDate] = useState(new Date());
    const onValueChangedInvoiceDate = useCallback((e: DateBoxTypes.ValueChangedEvent) => {
        setInvoiceDate(e.value);
    }, []);

    const [dueDate, setDueDateValue] = useState(dueCalDate);
    const onValueChangedDueDate = useCallback((e: DateBoxTypes.ValueChangedEvent) => {
        setDueDateValue(e.value);
    }, []);

    const [invoiceStatusCode, setinvoiceStatus] = useState("");

    const [invoiceQty, setorderQty] = useState("");
    const [receivedQty, setvendorApprovedQty] = useState("");

    const [invoiceProductCount, setInvoiceProductCount] = useState();
    const [receivedProductCount, setReceivedProductCount] = useState();

    const [invoiceAmount, setInvoiceAmount] = useState();
    const [receivedAmount, setReceivedAmount] = useState();

    const [billToValue, setBillToValue] = useState("");
    // const onValueChangedBillToValue = useCallback((e: TextBoxTypes.ValueChangedEvent) => {
    //     setBillToValue(e.value);
    // }, []);
    const onValueChangedBillToValue = useCallback((e: SelectBoxTypes.ValueChangedEvent) => {
        setBillToValue(e.value);
    }, []);

    const [invoiceValue, setInvoiceValue] = useState("");
    const onValueChangedInvoiceValue = useCallback((e: TextBoxTypes.ValueChangedEvent) => {
        setInvoiceValue(e.value);
    }, []);

    const [commentsValue, setCommentsValue] = useState("");
    const onValueChangedCommentsValue = useCallback((e: TextBoxTypes.ValueChangedEvent) => {
        setCommentsValue(e.value);
    }, []);



    const goToBack = () => {
        navigate(`/b2b/invoice-list`)
    }

    const order_supplier_status_cell_render = (data: any) => (t(data.invoiceReason != null ? ('syncflow:lb_order_line_reason_status_' + data.invoiceReason) : ""));


    const [shipToLookups, setShipToLookups] = useState();
    const getshipToLookups = async (customerCode: string) => {
        setShipToLookups(await invoiceService.getshipToLookups(customerCode))
    };


    const [shipToValue, setShipToValue] = useState("");
    const onValueChangedShipToValue = useCallback((e: SelectBoxTypes.ValueChangedEvent) => {
        setShipToValue(e.value);
        setBillToValue(e.value);
        locationParams = e.value;
        getOrderLookups(customerParams, locationParams);
    }, []);


    const [orderLookups, setOrdersLookups] = useState();
    const getOrderLookups = async (customerCode: string, locationCode: string) => {
        setOrdersLookups(await invoiceService.getOrdersLookups(customerCode, locationCode))
    };


    const [termsValue, setTermsValue] = useState(7);
    const onValueChangedTermsValue = useCallback((e: NumberBoxTypes.ValueChangedEvent) => {
        setTermsValue(e.value);

        var d = new Date();
        d.setDate(d.getDate() + e.value);
        setDueDateValue(d)
    }, []);


    const [termsLookups] = useState(new CustomStore({
        load: invoiceService.getTermsLookups,
    }));

    const onBeforeSend = async (e: any) => {
        e.request.setRequestHeader("Authorization", 'Bearer ' + localStorage.getItem(Config.VITE_APP_ACCESS_TOKEN_KEY as string))
    }

    const fileUploaderRef = useRef<FileUploader>(null);
    const [uploadedData, setUploadedData] = useState<any>();
    const [columns, setColumns] = useState<any>();
    const onUploaded = async (e: any) => {
        var response = JSON.parse(e.request.response);
        if (response.data) {
            setUploadedData(response.data);
            setColumns(Object.keys(response.data));
        }
    }

    const onUploadError = async (e: any) => {
        console.log(e.error);
        setUploadedData([]);
        setColumns([]);
    }

    return (
        <>
            <div className='row mb-4 justify-content-end'>
                <div className='col-auto'>
                    <Button
                        text={t("syncflow:btn_back")}
                        type="default"
                        icon="back"
                        stylingMode="contained"
                        onClick={goToBack}
                    />
                </div>
                {/* <div className='col-auto'>
                    <Button
                        text="Save"
                        type="default"
                        icon="save"
                        visible={invoiceStatusCode != "N" ? false : true}
                        onClick={onSave}
                    />
                </div> */}
            </div>


            <div className="card-body py-3" style={{ display: params.id ? 'block' : 'none' }}>
                <div className="table-responsive">
                    <table className="table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4">
                        <thead>
                            <tr className="fw-bold text-muted">
                                <th className="w-25px">
                                    <div className="form-check form-check-sm form-check-custom form-check-solid"></div>
                                </th>
                                <th className="min-w-120px">Customer</th>
                                <th className="min-w-120px">Ship To</th>
                                <th className="min-w-120px">Invoice No</th>
                                <th className="min-w-120px">Bill To</th>
                                <th className="min-w-120px">Invoice Date</th>
                                <th className="min-w-120px">Due Date</th>
                                <th className="min-w-120px">Comments</th>
                                <th className="min-w-120px">Orders</th>
                                <th className="min-w-120px">{t('syncflow:lb_product_count')}</th>
                                <th className="min-w-120px">{t('syncflow:lb_qty')}</th>
                                <th className="min-w-120px">{t('syncflow:lb_amount')}</th>
                                <th className="min-w-120px">{t('syncflow:lb_order_status')}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>
                                    <div className="form-check form-check-sm form-check-custom form-check-solid"></div>
                                </td>
                                <td><span className="text-gray-900 fw-bold text-hover-primary d-block fs-6">{(customerValue)}</span></td>
                                <td><span className="text-gray-900 fw-bold text-hover-primary d-block fs-6">{(shipToValue)}</span></td>
                                <td><span className="text-gray-900 fw-bold text-hover-primary d-block fs-6">{(invoiceValue)}</span></td>
                                <td><span className="text-gray-900 fw-bold text-hover-primary d-block fs-6">{(shipToValue)}</span></td>
                                <td><span className="text-gray-900 fw-bold text-hover-primary d-block fs-6">{(moment(invoiceDate).format("DD/MM/YYYY"))}</span></td>
                                <td><span className="text-gray-900 fw-bold text-hover-primary d-block fs-6">{(moment(dueDate).format("DD/MM/YYYY"))}</span></td>
                                <td><span className="text-gray-900 fw-bold text-hover-primary d-block fs-6">{(commentsValue)}</span></td>
                                <td><span className="text-gray-900 fw-bold text-hover-primary d-block fs-6">{(orderValue)}</span></td>
                                <td> <span className="text-gray-900 fw-bold text-hover-primary d-block fs-6">{(invoiceProductCount)}</span></td>
                                <td> <span className="text-gray-900 fw-bold text-hover-primary d-block fs-6">{(invoiceQty)}</span></td>
                                <td> <span className="text-gray-900 fw-bold text-hover-primary d-block fs-6">${(invoiceAmount)}</span></td>
                                <td><OrderStatusCell statusCode={invoiceStatusCode} isAllApproved={invoiceQty == receivedQty} label={t('syncflow:lb_order_supplier_status_' + invoiceStatusCode)} /></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                {/* <div className="row">
                    <label className="col-lg-1 col-form-label fw-bold fs-6">Attachments</label>
                    <div className="col-lg-2">
                        <div className="row">
                            <div className="fv-row">
                                <FileUploader
                                    ref={fileUploaderRef}
                                    //uploadMode="useButtons"
                                    uploadMode="instantly"
                                    selectButtonText="Add"
                                    labelText=""
                                    multiple={true}
                                    accept="image/*"
                                    onBeforeSend={onBeforeSend}
                                    onUploadError={onUploadError}
                                    onUploaded={onUploaded}
                                    uploadUrl={uploadUrl}
                                />
                            </div>
                        </div>
                    </div>
                </div> */}
            </div>



            <div style={{ display: params.id ? 'none' : 'block' }}>
                <div className="row">
                    <label className="col-lg-1 col-form-label fw-bold fs-6">Customer</label>
                    <div className="col-lg-2">
                        <div className="row">
                            <div className="fv-row">
                                <SelectBox
                                    name="customerLookups"
                                    dataSource={customerLookups}
                                    valueExpr="code"
                                    displayExpr="name"
                                    onValueChanged={onValueChangedCustomer}
                                    searchEnabled={true}
                                    showClearButton={true} >
                                    <Validator ref={validatorRefCustomer}>
                                        <RequiredRule message="Confirm Customer is required" />
                                    </Validator>
                                </SelectBox>

                            </div>
                        </div>
                    </div>

                    <label className="col-lg-1 col-form-label fw-bold fs-6">Ship To</label>
                    <div className="col-lg-2">
                        <div className="row">
                            <div className="fv-row">
                                <SelectBox
                                    name="shipToLookups"
                                    dataSource={shipToLookups}
                                    valueExpr="code"
                                    displayExpr="name"
                                    onValueChanged={onValueChangedShipToValue}
                                    searchEnabled={true}
                                    showClearButton={true} >
                                    <Validator ref={validatorRefShipTo}>
                                        <RequiredRule message="Confirm Ship To is required" />
                                    </Validator>
                                </SelectBox>
                            </div>
                        </div>
                    </div>

                    <label className="col-lg-1 col-form-label fw-bold fs-6">Orders</label>
                    <div className="col-lg-2">
                        <div className="row">
                            <div className="fv-row">
                                <SelectBox
                                    name="vendorsLookups"
                                    dataSource={orderLookups}
                                    valueExpr="code"
                                    displayExpr="name"
                                    onValueChanged={onValueChangedOrderNo}
                                    searchEnabled={true}
                                    showClearButton={true} >
                                    <Validator ref={validatorRefOrders}>
                                        <RequiredRule message="Confirm Orders is required" />
                                    </Validator>
                                </SelectBox>
                            </div>
                        </div>
                    </div>
                </div>


                <div className="row">
                    <label className="col-lg-1 col-form-label fw-bold fs-6">Comments</label>
                    <div className="col-lg-2">
                        <div className="row">
                            <div className="fv-row">
                                <TextBox onValueChanged={onValueChangedCommentsValue} value={commentsValue} />
                            </div>
                        </div>
                    </div>

                    <label className="col-lg-1 col-form-label fw-bold fs-6">Bill To</label>
                    <div className="col-lg-2">
                        <div className="row">
                            <div className="fv-row">
                                <SelectBox
                                    name="shipToLookups"
                                    dataSource={shipToLookups}
                                    valueExpr="code"
                                    displayExpr="name"
                                    onValueChanged={onValueChangedBillToValue}
                                    value={billToValue}
                                    disabled={true}
                                    searchEnabled={true}
                                    showClearButton={true} />
                                {/* <TextBox disabled={true} onValueChanged={onValueChangedBillToValue} value={billToValue} /> */}
                            </div>
                        </div>
                    </div>

                    <label className="col-lg-1 col-form-label fw-bold fs-6">Invoice Date</label>
                    <div className="col-lg-2">
                        <div className="row">
                            <div className="fv-row">
                                <DateBox
                                    defaultValue={invoiceDate}
                                    inputAttr={dateLabel}
                                    type="date"
                                    onValueChanged={onValueChangedInvoiceDate}
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <label className="col-lg-1 col-form-label fw-bold fs-6">Terms</label>
                    <div className="col-lg-2">
                        <div className="row">
                            <div className="fv-row">
                                {/* <SelectBox
                                    name="vendorsLookups"
                                    onValueChanged={onValueChangedTermsValue}
                                    dataSource={termsLookups}
                                    valueExpr="code"
                                    displayExpr="name"
                                    searchEnabled={true}
                                    showClearButton={true} /> */}
                                <NumberBox defaultValue={7} onValueChanged={onValueChangedTermsValue} >
                                    <Validator ref={validatorRefTerms}>
                                        <RequiredRule message="Confirm Terms is required" />
                                    </Validator>
                                </NumberBox>
                            </div>
                        </div>
                    </div>

                    <label className="col-lg-1 col-form-label fw-bold fs-6">Due Date</label>
                    <div className="col-lg-2">
                        <div className="row">
                            <div className="fv-row">
                                <DateBox
                                    value={dueDate}
                                    inputAttr={dateLabel}
                                    type="date"
                                    onValueChanged={onValueChangedDueDate}
                                />
                            </div>
                        </div>
                    </div>

                    <label className="col-lg-1 col-form-label fw-bold fs-6">Invoice No</label>
                    <div className="col-lg-2">
                        <div className="row">
                            <div className="fv-row">
                                <TextBox onValueChanged={onValueChangedInvoiceValue} value={invoiceValue}>
                                </TextBox>
                            </div>
                        </div>
                    </div>
                </div>

                {/* <div className="row">
                    <label className="col-lg-1 col-form-label fw-bold fs-6">Attachments</label>
                    <div className="col-lg-2">
                        <div className="row">
                            <div className="fv-row">
                                <FileUploader
                                    uploadMode="useButtons"
                                    selectButtonText="Add"
                                    labelText=""
                                    multiple={true}
                                    accept="image/*"
                                    uploadUrl={uploadUrl}
                                />
                            </div>
                        </div>
                    </div>
                </div> */}
            </div>




            <React.Fragment>
                <DataGridWrapper
                    props={{ ref: dataGridRef }}
                    datasource={store}
                    remoteOperations={false}
                    showColumnLines={true}
                    columnChooser={true}
                    pagerVisible={true}
                    onSaving={onSaving}
                    filterVisible={true}
                    headerFilterVisible={true}
                    keyboardNavigation={true}
                    excellExport={true}
                    onFocusedCellChanging={onFocusedCellChanging}
                    onInitNewRow={handleInitNewRow}
                    editingConfig={{
                        mode: "batch",
                        useIcons: true,
                        allowAdding: false,
                        allowDeleting: false,
                        allowUpdating: true,
                        updateMessageText: RemoveMessage('Resource'),
                    }}

                    columns={[
                        {
                            dataField: 'orderCode',
                            caption: "Order No",
                            allowFiltering: true,
                            allowEditing: false,
                        },
                         {
                            dataField: 'waybillNo',
                            caption: "Waybill No",
                            allowFiltering: true,
                            allowEditing: false,
                        },

                        {
                            dataField: 'productName',
                            caption: "Product Name",
                            allowFiltering: true,
                            allowEditing: false,
                        },
                        {
                            dataField: 'unit',
                            caption: "Unit",
                            allowFiltering: true,
                            allowEditing: false,
                        },
                        {
                            dataField: 'unitPrice',
                            caption: "Unit Price",
                            allowFiltering: true,
                            allowEditing: false,
                            format: { style: "currency", currency: "USD", useGrouping: true },
                        },
                        {
                            dataField: 'approvedQty',
                            caption: "Qty",
                            allowFiltering: true,
                            allowEditing: false,
                        },
                        // {
                        //     dataField: 'receivedQty',
                        //     caption: "Received Qty",
                        //     allowFiltering: true,
                        //     allowEditing: false,
                        //     visible: params.id ? true : false
                        // },
                        // {
                        //     dataField: 'invoiceReason',
                        //     caption: "Reason",
                        //     allowFiltering: true,
                        //     allowEditing: false,
                        //     calculateCellValue: order_supplier_status_cell_render,
                        //     visible: params.id ? true : false
                        // },
                        {
                            dataField: 'totalAmount',
                            caption: "Total Amount",
                            allowFiltering: true,
                            allowEditing: false,
                            format: { style: "currency", currency: "USD", useGrouping: true },
                        }
                    ]}
                />
            </React.Fragment>

            <Popup
                visible={popupVisible}
                onHiding={hideInfo}
                title="Order products list"
                showTitle={true}
                width={1200}
                height={740}
                position={{ of: window, at: 'center', my: 'center' }}
            >

                <div className='row mb-4 justify-content-end'>
                    <div className='col-auto'>
                        <Button
                            text={t("syncflow:btn_approve")}
                            type="default"
                            stylingMode="contained"
                            icon="check"
                            onClick={approveFunc}
                        />
                    </div>
                </div>
                <DataGridWrapper
                    props={{ ref: dgVendorSummaryRef }}
                    datasource={storeVendorSummaries}
                    showColumnLines={true}
                    onSelectionChanged={onSelectionChanged}
                    remoteOperations={false}
                    columnChooser={false}
                    pagerVisible={true}
                    filterVisible={true}
                    headerFilterVisible={true}
                    selectionConfig={{ mode: 'multiple', selectAllMode: 'allPages', showCheckBoxesMode: 'always' }}
                    editingConfig={{
                        mode: "batch",
                        allowDeleting: false,
                        allowUpdating: true,

                    }}
                    columns={[
                        {
                            dataField: 'retailerSourceName',
                            caption: 'Source Name',
                            allowFiltering: false,
                            allowEditing: false,
                        },
                        {
                            dataField: 'retailerProductName',
                            caption: 'Product Name',
                            allowFiltering: false,
                            allowEditing: false,
                        },
                        {
                            dataField: 'retailerProductCategory01Name',
                            caption: 'Product Category Name',
                            allowFiltering: false,
                            allowEditing: false,
                        },
                        {
                            dataField: 'priceCurrency',
                            caption: 'Price Currency',
                            allowFiltering: false,
                            allowEditing: false,
                        },
                        {
                            dataField: 'price',
                            caption: 'Price',
                            allowFiltering: false,
                            allowEditing: false,
                            format: { style: "currency", currency: "USD", useGrouping: true }
                        },
                        {
                            dataField: 'orderQty',
                            caption: 'Order Qty',
                            allowFiltering: false,
                            allowEditing: false,
                        },
                        {
                            dataField: 'orderLinesApprovedQty',
                            caption: 'Approved Qty',
                            allowFiltering: false,
                            allowEditing: false,
                        }
                    ]}
                />
            </Popup>



        </>


    )
}
export default InvoiceRecording